import { useState, useRef, useEffect, useMemo, useCallback,forwardRef,useImperativeHandle } from 'react';
import Style from "../css/style.module.css";
import getXcolumnJson from "./xcolumn/list";
import strFunc from '@/lib/lyg/string';

const VideoSectionList = forwardRef((props:any, ref) => {
  const myProps={
    
    ...props
  };
  
  const xColumnArr=getXcolumnJson();
  const [section_arr,set_section_arr]=useState([]);
  const [video_arr,set_video_arr]=useState<any>([]);

  const setInitData=(inOptObj:any)=>{
    if(inOptObj==undefined){
      inOptObj={};
    }
    let optObj={
      "section_arr":[],
      "video_arr":[],
      ...inOptObj
    };
    if(optObj.section_arr){
      set_section_arr(optObj.section_arr);
    }
    if(optObj.video_arr){
      set_video_arr(optObj.video_arr);
    }
  };

  const onChangeVideoCheck=(video_seq:string,is_checked:boolean)=>{
    let tmp_video_arr:any=[...video_arr];
    for(let i=0;i<tmp_video_arr.length;i++){
      let video_info=tmp_video_arr[i];
      if(video_info.a_seq==video_seq){
        tmp_video_arr[i].is_checked=is_checked;
      }
    }
    set_video_arr(tmp_video_arr);
  };
  const onChangeSectionCheck=(select_seq:string,is_checked:boolean)=>{
    let tmp_video_arr:any=[...video_arr];
    for(let i=0;i<tmp_video_arr.length;i++){
      let video_info=tmp_video_arr[i];
      if(video_info["a_section_seq"]==select_seq){
        tmp_video_arr[i].is_checked=is_checked;
      }
    }
    set_video_arr(tmp_video_arr);
  }
  const onChangeAllCheck=(is_checked:boolean)=>{
    let tmp_video_arr:any=[...video_arr];
    for(let i=0;i<tmp_video_arr.length;i++){
      tmp_video_arr[i].is_checked=is_checked;
    }
    set_video_arr(tmp_video_arr);
  };

  const get_select_video_list=()=>{
    let select_video_list=[];
    for(let i=0;i<video_arr.length;i++){
      if(video_arr[i].is_checked){
        select_video_list.push(video_arr[i]);
      }
    }
    return select_video_list;
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData,get_select_video_list
  }));

  const getVideoArrBySection=(section_seq:string)=>{
    let show_video_list:any=[];
    if(section_seq=="empty"){
      for(let i=0;i<video_arr.length;i++){
        let video_info=video_arr[i];
        let tmp_is_exist=false;
        for(let j=0;j<section_arr.length;j++){
          let section_info=section_arr[j];
          if(video_info["a_section_seq"]==section_info["a_seq"]){
            tmp_is_exist=true;
          }
        }
        if(tmp_is_exist==false){
          show_video_list.push(video_info);
        }
      }
    }else{
      for(let i=0;i<video_arr.length;i++){
        let video_info=video_arr[i];
        if(video_info["a_section_seq"]==section_seq){
          show_video_list.push(video_info);
        }
      }
    }
    return show_video_list;
  };
  
  const getVideoListTableBySection=(section_seq:string)=>{
    let show_video_list=getVideoArrBySection(section_seq);
    let video_row_tags=show_video_list.map((item:any,idx:number)=>{
      return (
        <tr key={idx}>
          {xColumnArr.x_column_list_arr.map((col_data:any,col_idx:number)=>{
            let key=col_data["key"];
            let val_str:any="";
            if(item[key]){
              val_str=item[key];
              if(xColumnArr.select_arr[key]){
                for(let i=0;i<xColumnArr.select_arr[key].length;i++){
                  if(xColumnArr.select_arr[key][i]["value"]==val_str){
                    val_str=xColumnArr.select_arr[key][i]["text"];
                  }
                }
              }
            }
            if(key=="row_view_time"){
              let row_sec_num=parseInt(strFunc.uncomma(item["a_total_sec"]));
              let row_min_num=0;
              if(row_sec_num>0){
                row_min_num=Math.floor((row_sec_num/60));
              }
              val_str=(
                <div className="text-center">
                  {row_min_num} 분
                </div>
              );
            }
            let style_str:any={
              maxWidth:col_data["width"],
              overFlow:"hidden",
            };
            if(key=="check_box"){
              val_str=(<input type="checkbox" checked={item.is_checked?true:false} onChange={(e:any)=>{onChangeVideoCheck(item.a_seq,e.target.checked);}}/>);
              style_str={textAlign:"center"};
            }
            return  (
              <td key={col_idx}>
                <div style={style_str}>
                  {val_str}
                </div>
              </td>
            );
          })}
        </tr>
      );
    });
    if(strFunc.is_empty(video_row_tags)){
      video_row_tags=(
        <tr>
          <td colSpan={99}>
            <div style={{width:"100%",textAlign:"center",height:30,lineHeight:"30px"}}>내용이 없습니다.</div>
          </td>
        </tr>
      );
    }
    let colgroup_row_tags=xColumnArr.x_column_list_arr.map((col_data:any,col_idx:number)=>{
      return (
        <col key={col_idx} width={col_data["width"]+"px"}></col>
      );
    });
    let thead_row_tags=xColumnArr.x_column_list_arr.map((col_data:any,col_idx:number)=>{
      let title_str=col_data["name"];
      let style_str:any={
        maxWidth:col_data["width"],
        overFlow:"hidden",
      };
      if(col_data["key"]=="check_box"){
        title_str=(<input type="checkbox" onChange={(e:any)=>{onChangeSectionCheck(section_seq,e.target.checked);}} />);
      }
      return (
        <th key={col_idx} >
          <div style={style_str}>
            {title_str}
          </div>
        </th>
      );
    });
    let video_table_tag=(
      <table>
        <colgroup>
          {colgroup_row_tags}
        </colgroup>
        <thead>
          <tr>
            {thead_row_tags}
          </tr>
        </thead>
        <tbody>
          {video_row_tags}
        </tbody>
      </table>
    );
    return video_table_tag;
  };
  const getVideoSectionTags=()=>{
    let section_tags=section_arr.map((item:any,idx:number)=>{
      let video_table_tag=getVideoListTableBySection(item.a_seq);
      return (
        <div key={idx} className={Style.section_item}>
          <div className={Style.section_item_title} >{item.a_title}</div>
          <div className={Style.Video_list_wrap+"  list-table-div"} >
            {video_table_tag}
          </div>
        </div>
      );
    });
    let tmp_empty_section=getVideoArrBySection("empty");
    let empty_section_tag:any="";
    if(tmp_empty_section.length>0){
      let empty_video_table_tag:any=getVideoListTableBySection("empty");
      empty_section_tag=(
        <div className={Style.section_item}>
          <div className={Style.section_item_title} >소속없음</div>
          <div className={Style.Video_list_wrap+"  list-table-div"} >
            {empty_video_table_tag}
          </div>
      </div>
      );
    }

    return (
      <>
        {section_tags}
        {empty_section_tag}
      </>
    );
  };

  let Video_section_tags:any=getVideoSectionTags();

  return (
    <div>
      <div className="px-2 py-2">
        <label>
          <input type="checkbox" onChange={(e:any)=>{onChangeAllCheck(e.target.checked);}}/> 전체체크
        </label>
      </div>
      {Video_section_tags}
    </div>
  );
});

export default VideoSectionList;
